<div class="layout-footer">
    <span class="footer-text-left">
        <script type="text/javascript">
            var __dcid = __dcid || [];
            __dcid.push({
                cid: 'DigiCertClickID_WnvNgHJ9',
                tag: 'WnvNgHJ9'
            });
            (function () {
                var cid = document.createElement('script');
                cid.async = true;
                cid.src = '//seal.digicert.com/seals/cascade/seal.min.js';
                var s = document.getElementsByTagName('script');
                var ls = s[s.length - 1];
                ls.parentNode.insertBefore(cid, ls.nextSibling);
            })();
        </script>
    </span>
    <span class="footer-text-right">
        <a href="#" title="Home"><i class="fa fa-fw fa-home"></i></a>
        <a href="#" title="Twitter" hidden><i class="fa fa-twitter"></i></a>
        <a href="#" title="Github" hidden><i class="fa fa-github"></i></a>
    </span>

    <div
        class="admin-footer-message"
        *ngIf="adminFooterMessage$ | async as adminFooterMessage"
    >
        <a
            *ngIf="adminFooterLink$ | async as adminFooterLink; else noLink"
            target="_blank"
            rel="noopener"
            [href]="adminFooterLink"
        >
            {{ adminFooterMessage }}
        </a>
        <ng-template #noLink>
            {{ adminFooterMessage }}
        </ng-template>
    </div>
    <div *ngIf="environment.production == false" class="flex items-center">
        TEST Environment {{ environment.version }}-{{ environment.environment }}
    </div>
    <!-- <div class="beta-notification" *ngIf="ShowBetaMessage" style="display:none">
        <span class="version-footer">
            <span style="color: #00562b; font-size: larger" class="bold"
                >eFAACT</span
            >&nbsp;<span>Version: {{ environment.version }}-{{
                environment.environment
            }}</span>&nbsp;
            <span>API Version: {{ version$ | async }}</span>
        </span>
        <a style="margin-left: 1em;" href=" https://efaactcentral.com/releasenotes/efaactreleasenotes.htm" target="_blank">Release Notes</a>
    </div> -->
</div>
